import configureStoreDev from './index.dev';
import configureStoreProd from './index.prod';

// `import.meta.env.DEV` is a build-time constant (Vite replaces it with a literal
// true/false), so Rollup/Rolldown tree-shakes away whichever of the two static imports above
// isn't selected in a production build — unlike the CommonJS `require()`-based dispatch this
// replaces, which chose the module at require-time based on `process.env.NODE_ENV`.
export default import.meta.env.DEV ? configureStoreDev : configureStoreProd;
